import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { deleteUser, getUserById } from '../../../../../Constants/Api/functions/function';

import { Avatar, Button, Spin, Popconfirm, notification, Tag } from 'antd'
import {
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons'

import EditOverview from './EditOverview'

import './style.scss'
import { DEFAULT_USER_PROFILE_IMAGE } from '../../../../../Constants/Api/azure/azure';

const UserOverview = ({ selectedUser }) => {
    const url = window.location.pathname;
    const [Loading, setLoading] = useState(true)
    const [user, setUser] = useState(null)
    const [editOverviewOpen, setEditOverviewOpen] = useState(false)
    const [api, contextHolder] = notification.useNotification();
    const [userId, setUserId] = useState()
    const userProfile = useSelector(state => state.userProfile.userProfile)

    useEffect(() => {
        if (url.includes('users')) {
            const userId = url.split('/')[3];
            setUserId(userId)
        } else {
            setUserId(userProfile.id)
        }
    }, [url, userProfile])


    useEffect(() => {
        if (url.includes('users')) {
            if (selectedUser) {
                setLoading(false)
                setUser(selectedUser)
            } else {
                if (userId) {
                    handleGetUser()
                }
            }
        } else {
            setLoading(false)
            setUser(userProfile)
        }
    }, [selectedUser, url, userProfile, userId])

    const handleGetUser = async () => {
        setLoading(true)
        try {
            const response = await getUserById(userId)
            if (response) {
                setUser(response)
            }
        } catch (error) {
            console.error('getUser', error)
        }
        setLoading(false)
    }

    const handleUserDelete = async () => {
        try {
            const response = await deleteUser(userId)
            if (response && response.status === 200) {
                deleteUserNotification('success')
                window.location = '/dashboard/users'
            } else {
                deleteUserNotification('error', 'Something went wrong')
            }
        } catch (error) {
            deleteUserNotification('error', error)
        }
    }

    const deleteUserNotification = (type, description) => {
        api[type]({
            message: type === 'success' ? 'Success' : 'Something went wrong',
            description: type === 'success'
                ? 'User deleted successfully'
                : `Error: ${description}`,
        });
    };

    const getRoleTag = () => {
        const role = user?.role;
        let color = 'geekblue';
        if (role === 'superadmin') {
            color = 'volcano';
        }
        if (role === 'student') {
            color = 'blue';
        }
        return (
            <Tag color={color} key={role}>
                {role?.toUpperCase()}
            </Tag>
        );
    };

    const getIndexNumber = (name, index) => {
        const firstLetter = name?.charAt(0).toUpperCase();
        if (firstLetter && index) {
            return `${firstLetter}${index}`
        } else {
            return 'Please wait...'
        }
    }

    return (
        <Spin
            spinning={Loading}
            tip='Loading...'
        >
            <div className='user-overview'>
                {contextHolder}
                <h1>
                    Basic info
                    {userProfile?.role === 'superadmin' &&
                        <Popconfirm
                            title="Delete user?"
                            description="Are you sure you want to delete this user?"
                            onConfirm={handleUserDelete}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                style={{
                                    transform: 'translateY(-1px)',
                                    marginLeft: '15px',
                                }}
                                size='small'
                                danger>
                                Delete <DeleteOutlined />
                            </Button>
                        </Popconfirm>}
                    <Button
                        type='link'
                        style={{
                            transform: 'translateY(-1px)',
                            padding: 0,
                            marginLeft: '15px',
                        }}
                        onClick={() => setEditOverviewOpen(true)}
                    >
                        Edit <EditOutlined />
                    </Button>
                </h1>

                <div className='user-overview__basic-info'>
                    <div className='user-overview__basic-info__image'>
                        <div className='left'>
                            <Avatar
                                src={user?.profileImage || DEFAULT_USER_PROFILE_IMAGE}
                                size={100}
                            />
                        </div>
                    </div>

                    <div className='details'>
                        <section className='left'>
                            <div>
                                <h4>User Name</h4>
                                <p>
                                    {user?.name}
                                </p>
                            </div>

                            <div>
                                <h4>Index Number</h4>
                                <p>
                                    {getIndexNumber(user?.name, user?.indexNumber)}
                                </p>
                            </div>

                            <div>
                                <h4>User ID</h4>
                                <p>
                                    {user?.id}
                                </p>
                            </div>

                            <div>
                                <h4>Email</h4>
                                <p>
                                    {user?.email}
                                </p>
                            </div>
                        </section>

                        <section className='right'>
                            <div>
                                <h4>Created Date Time</h4>
                                <p>
                                    {
                                        user?.createdAt
                                    }
                                </p>
                            </div>

                            <div>
                                <h4>Role</h4>
                                <p>
                                    {getRoleTag()}
                                </p>
                            </div>

                            <div>
                                <h4>Contact Number</h4>
                                <p>
                                    {user?.contactNumber || 'N/A'}
                                </p>
                            </div>

                            <div>
                                <h4>Address</h4>
                                <p>
                                    {user?.address || 'N/A'}
                                </p>
                            </div>
                        </section>
                    </div>
                </div>
                <EditOverview
                    open={editOverviewOpen}
                    setOpen={setEditOverviewOpen}
                    user={user}
                    getUser={handleGetUser}
                />
            </div>
        </Spin>
    )
}

export default UserOverview